'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ViewTypes = exports.ViewTypes = {
  List: 'list',
  Map: 'map'
};

var ReservedOptions = exports.ReservedOptions = {
  hasDirectReservationPlans: 'hasDirectReservationPlans',
  hasLastMinuteDiscountPlans: 'hasLastMinuteDiscountPlans',
  ownerRank: 'ownerRank',
  TopHost: 'TOP_HOST'
};

var StayRoomTypes = exports.StayRoomTypes = {
  SHARED_ROOM: 'SHARED_ROOM',
  PRIVATE_ROOM: 'PRIVATE_ROOM',
  ENTIRE_PLACE: 'ENTIRE_PLACE'
};


//////////////////
// WEBPACK FOOTER
// ./~/frontend_core/dist/constants/search.js
// module id = 835
// module chunks = 0